export default function (element, dataset) {
  // console.log("chaptersection initialized", element, dataset);
  const hasCookie = document.cookie.includes("goose=true");
  const hasDirectAccess = new URLSearchParams(window.location.search).has(
    "directaccess"
  );
  console.log("chaptersection Has Cookie", hasCookie);
  console.log("chaptersection Has Direct Access", hasDirectAccess);
  if (hasCookie || hasDirectAccess) {
    element.dataset.chapters = "unlocked";
  }
}
